import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Protected from './components/Protected';
import Navbar from './components/Navbar';
import LoginPage from './pages/LoginPage';
import SubscribePage from './pages/SubscribePage';
import HomePage from './pages/HomePage';
import TowersOfHanoi from './pages/TowersOfHanoi';
import TicTacToe from './pages/TicTacToe';
import Connect4 from './pages/Connect4';
import Sudoku from './pages/Sudoku';
import UltimateTicTacToe from './pages/UltimateTicTacToe';
import Chess from './pages/Chess';
import Tetris from './pages/Tetris';
import Snake from './pages/Snake';
import Pong from './pages/Pong';
import Hashiwokakero from './pages/Hashiwokakero';
import KnightsTour from './pages/KnightsTour';
import GameOfLife from './pages/GameOfLife';
import Go from './pages/Go';
import RockPaperScissors from './pages/RockPaperScissors';
import SydneyTrainGame from './pages/SydneyTrainGame';
import PegSolitaire from './pages/PegSolitaire';
import BrickBreaker from './pages/BrickBreaker';
import NQueens from './pages/NQueens';
import Minesweeper from './pages/Minesweeper';
import Battleships from './pages/Battleships';
import Othello from './pages/Othello';
import BubbleBurst from './pages/BubbleBurst';
import Banagrams from './pages/Banagrams';

function App() {
  return (
    <AuthProvider>
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-grow container mx-auto px-4 py-8">
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route element={<Protected />}>
              <Route path="/subscribe" element={<SubscribePage />} />
            </Route>
            <Route element={<Protected needAccess />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/game/towers-of-hanoi" element={<TowersOfHanoi />} />
              <Route path="/game/tic-tac-toe" element={<TicTacToe />} />
              <Route path="/game/connect4" element={<Connect4 />} />
              <Route path="/game/sudoku" element={<Sudoku />} />
              <Route path="/game/ultimate-tic-tac-toe" element={<UltimateTicTacToe />} />
              <Route path="/game/chess" element={<Chess />} />
              <Route path="/game/tetris" element={<Tetris />} />
              <Route path="/game/snake" element={<Snake />} />
              <Route path="/game/pong" element={<Pong />} />
              <Route path="/game/hashiwokakero" element={<Hashiwokakero />} />
              <Route path="/game/knights-tour" element={<KnightsTour />} />
              <Route path="/game/game-of-life" element={<GameOfLife />} />
              <Route path="/game/go" element={<Go />} />
              <Route path="/game/rock-paper-scissors" element={<RockPaperScissors />} />
              <Route path="/game/sydney-train-game" element={<SydneyTrainGame />} />
              <Route path="/game/peg-solitaire" element={<PegSolitaire />} />
              <Route path="/game/brick-breaker" element={<BrickBreaker />} />
              <Route path="/game/n-queens" element={<NQueens />} />
              <Route path="/game/minesweeper" element={<Minesweeper />} />
              <Route path="/game/battleships" element={<Battleships />} />
              <Route path="/game/othello" element={<Othello />} />
              <Route path="/game/bubble-burst" element={<BubbleBurst />} />
              <Route path="/game/banagrams" element={<Banagrams />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <footer className="bg-surface py-4 text-center text-gray-400">
          <div className="container mx-auto">
            <p>Arcade Games &copy; {new Date().getFullYear()}</p>
          </div>
        </footer>
      </div>
    </AuthProvider>
  );
}

export default App; 